import { render, staticRenderFns } from "./SigninTemplate.vue?vue&type=template&id=0bab3bbe"
import script from "./SigninTemplate.vue?vue&type=script&lang=js"
export * from "./SigninTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports